import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import { useTranslation } from "next-i18next";
import { useQuery } from "@tanstack/react-query";
import { getDLanguages } from "api/developmentResearchUser";
import ILanguage from "interfaces/interface_languages";
import Popper from "./Common/Popper";

const LanguageSelector = () => {
  const router = useRouter();
  const { locale, pathname, asPath } = router;
  const [image, setImage] = useState();

  const { i18n } = useTranslation();

  const { data: languagesList } = useQuery(["getDLanguages", locale], () => getDLanguages(locale));

  useEffect(() => {
    if (localStorage.getItem("lang")) {
    } else {
      localStorage.setItem("lang", "fa");
    }

    document.body.style.direction = i18n.dir();
    document.dir = i18n.dir();
  }, [i18n]);

  useEffect(() => {
    let temp = languagesList?.data?.find((el: ILanguage) => el.key === locale)?.flag;
    if (temp) {
      setImage(temp);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languagesList, locale]);

  return (
    <>
      <Popper
        noHover
        title={
          <div className=" flex cursor-pointer items-center">
            <i className=" icon-direction- rotate-90 text-20 text-white me-8 " />
            <span className="text-18 uppercase text-white ms-2 me-12 ">{locale}</span>

            {image && (
              <div className="relative h-26 w-26 overflow-hidden rounded-full">
                <Image fill className="object-cover" alt={locale as string} src={image} />
              </div>
            )}
          </div>
        }
      >
        <div>
          {languagesList?.data?.map((item: ILanguage, i: number) => {
            return (
              <div
                key={i}
                className="mb-12 flex w-full cursor-pointer items-center justify-between"
                onClick={async () => {
                  i18n.changeLanguage(item?.key);
                  localStorage.setItem("lang", item?.key);
                  await router.push(`${pathname}`, `${asPath}`, {
                    locale: item?.key,
                  });
                }}
              >
                <p className={`${item?.direction === "ltr" ? "font-eng" : "font-sans"}  text-12`}>
                  {item?.value}
                </p>
                {!!item?.flag && (
                  <div className="relative h-26 w-26 overflow-hidden rounded-full">
                    <Image fill className="object-cover" alt={item?.key} src={item?.flag} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </Popper>
    </>
  );
};

export { LanguageSelector };
